import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Table, Row } from 'reactstrap';
import { t } from '../common/Translate';

const HistoryModal = ({ historys, toggle, modal, dateFormat }) => (
  <div>
    <Modal isOpen={modal} toggle={toggle} className="modal-lg">
      <ModalBody className="remove-padding">
        <h2>{t('pricingHistoryTitle')}</h2>
        <Table responsive="sm">
          <thead>
            <tr>
              <td className="text-bold">{t('dateHourHistory')}</td>
              <td className="text-bold">{t('userHistory')}</td>
              <td className="text-bold">{t('modificationsHistory')}</td>
            </tr>
          </thead>
          <tbody>
            {historys.map((i) => (
              <tr key={i.id}>
                <td>{i.createdAt && moment(i.createdAt).format(dateFormat)}</td>
                <td>{`${i.userFirstName} ${i.userLastName}`}</td>
                <td>
                  <BodyInfos body={i.body} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-1" onClick={toggle}>
          {t('close')}
        </button>
      </ModalFooter>
    </Modal>
  </div>
);

HistoryModal.propTypes = {
  historys: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
};

export default HistoryModal;

const BodyInfos = (res) => {
  const { body } = res;
  return Object.entries(body).map((i) => (
    <Row>
      <span>
        {t(i[0])} {i[1] && `: ${t(i[1])}`}
      </span>
    </Row>
  ));
};
